export const initialValues = {
  productId: 0,
  productName: "",
  category: "",
  imageUrl: "",
  price: "",
  quantity: "",
};
